<template>
  <Dialog
    :visible="visible"
    modal
    :header="state?.header"
    :closable="!loading"
    :style="{ width: '28rem' }"
    @update:visible="handleCancel"
  >
    <p class="m-0">{{ state?.message }}</p>
    <ul v-if="state?.items?.length" class="confirm-items-list">
      <li v-for="(item, index) in state.items" :key="index">{{ item }}</li>
    </ul>
    <template #footer>
      <Button
        label="Cancel"
        outlined
        :disabled="loading"
        @click="handleCancel"
      />
      <Button
        label="Yes"
        :severity="state?.danger ? 'danger' : undefined"
        :loading="loading"
        @click="handleAccept"
      />
    </template>
  </Dialog>
</template>

<script setup>
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import { useConfirmAction } from "../composables/useConfirmAction";

const { visible, state, loading, handleAccept, handleCancel } =
  useConfirmAction();
</script>

<style scoped>
.confirm-items-list {
  margin: 0.75rem 0 0 0;
  padding-left: 1.25rem;
  max-height: 14rem;
  overflow-y: auto;
  font-size: 0.85rem;
  color: var(--text-color-secondary);
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
</style>
